export default __webpack_public_path__ + "static/apple-touch-icon-3b92b228eca41f7624b4f84bb6637d8c.png";